import { RadioButton } from 'primereact/radiobutton';
import { classNames } from 'primereact/utils';
import type React from 'react';
import style from '../views/program.module.css';
import { CustomText, TextBodySmall } from '@/components/text/Texts';
import { Column } from '@/components/container/Container';
import { cn } from '@/components/ui/cn';

type Props = {
	type: string;
	handleChange: (value: string) => void;
};

type RadioT = 'old' | 'new';

const SelectCopyOrNew = (props: Props) => {
	const { type, handleChange } = props;

	const handleKeyDown = (e: React.KeyboardEvent, type: RadioT) => {
		if (e.key === 'Enter' || e.key === ' ') handleChange(type);
	};

	const ProgramCard = (title: string, value: RadioT) => {
		const isChecked = type === value;

		return (
			<Column
				className={cn(
					'p-4 bg-surfaceContainer rounded-[28px] duration-300',
					isChecked && 'shadow-[inset_0_0_0_2px_theme(colors.primary60)]'
				)}
				onClick={() => handleChange(value)}
				onKeyDown={(e) => handleKeyDown(e, value)}
			>
				<RadioButton
					onChange={() => handleChange(value)}
					checked={isChecked}
					value={value}
					className="self-end my-3.5 mr-3.5"
					pt={{
						box: { className: cn('border-2 duration-200', isChecked ? 'border-primary' : 'border-neutralVariant20') },
						icon: { className: 'bg-primary' },
					}}
				/>
				<CustomText
					className="mb-3 mt-2 text-[20px] font-semibold leading-[24px] tracking-[0.1px] text-primary"
					text={title}
				/>
				<TextBodySmall
					className="text-black"
					text="Start from scratch and set limits for time, location, and other parameters to customize your Xpress for Business settings."
				/>
			</Column>
		);
	}

	return (
		<div className="grid grid-cols-1 md:grid-cols-2 gap-5">
			{ProgramCard('Copy an existing program', 'old')}
			{ProgramCard('Build your own program', 'new')}
		</div>
	);
};

export default SelectCopyOrNew;
